module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-MediumItalic.woff?16f319ceb9112ed909d138d810a38f63";